import { get, reduce, isEmpty } from "lodash"
import { createSelector } from "reselect"
import { createQueryStringSelector } from "selectors/queryString"
import { getSelectedColumns as getDefaultSelectedColumns } from "selectors/securities-table"
import { getUserPreference } from "helpers/userPreferences"

const EMPTY_OBJECT = {}
const EMPTY_ARRAY = []

function mapQueryStringColumns(queryStringColumns) {
  return reduce(queryStringColumns, (allSelected, columns, columnType) => {
    const fullColumnNames = reduce(columns, (fullNames, column) => ({ ...fullNames, [`${columnType}.${column}`]: true }), {})

    return {
      ...allSelected,
      ...fullColumnNames,
    }
  }, {})
}

export const getHistoricalFactorSensitivityIsAvailable = state => get(state, "global.data.historicalFactorSensitivityAvailability.data")
export const getSort = createQueryStringSelector("sort")
export const getPage = createQueryStringSelector("page", 0, { as: "number" })
const getRawSelectedColumns = createQueryStringSelector("columns", EMPTY_OBJECT)

const getRawAdditionalColumns = createQueryStringSelector("additionalColumns", EMPTY_ARRAY)
const getAdditionalColumns = createSelector(
  [getRawAdditionalColumns],
  mapQueryStringColumns,
)

export const getQueryStringSelectedColumns = createSelector(
  [getRawSelectedColumns],
  mapQueryStringColumns,
)

const getRawSecurityFinderPreferences = state => get(state, "global.data.securityFinderPreferences.data")
const getUserPreferenceColumns = createSelector(
  [getRawSecurityFinderPreferences],
  (preferences) => getUserPreference(preferences, "securityFinderSelectedColumns", EMPTY_OBJECT),
)

export const getSelectedColumns = createSelector(
  [getDefaultSelectedColumns, getAdditionalColumns, getQueryStringSelectedColumns, getUserPreferenceColumns],
  (defaultSelectedColumns, additionalColumns, queryStringSelectedColumns, userPreferenceColumns) => {
    if (!isEmpty(queryStringSelectedColumns)) {
      return queryStringSelectedColumns
    }

    return {
      ...(isEmpty(userPreferenceColumns) ? defaultSelectedColumns : userPreferenceColumns),
      ...additionalColumns,
    }
  },
)
